import React, {Component} from "react";
import FlexView from "react-flexview";
import M from "moment";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";

class PenyerahanBBNLeasingFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: {},
            dataVariant: [],
            dataWarna: [],
        };
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    render() {
        return (
            <SimpleModal
                title="Filter Search"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <FlexView column>
                            <SimpleInput
                                id="input_text_submission_number"
                                name="handOverNumber"
                                label="No. Penyerahan"
                                value={this.props.selectedData.handOverNumber}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value?.trim())
                                }
                            />
                            <FlexView column vAlignContent="center">
                                <p>Tanggal Penyerahan:</p>
                                <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                    <SimpleDate
                                        date={this.props.selectedData.startPeriod}
                                        onChange={(value) =>
                                            this.props.onValueChange("startPeriod", M(value).format("DD-MM-YYYY"))
                                        }
                                    />
                                    <span className="margin-bottom-20px">To</span>
                                    <SimpleDate
                                        date={this.props.selectedData.endPeriod}
                                        onChange={(value) =>
                                            this.props.onValueChange("endPeriod", M(value).format("DD-MM-YYYY"))
                                        }
                                    />
                                </FlexView>
                            </FlexView>
                            <SimpleInput
                                id="input_text_leasing_name"
                                name="leasingName"
                                label="Nama Leasing"
                                value={this.props.selectedData.leasingName}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value?.trim())
                                }
                            />
                            <SimpleInput
                                id="input_text_recipient_name"
                                name="receiptName"
                                label="Nama Penerima"
                                value={this.props.selectedData.receiptName}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value?.trim())
                                }
                            />
                            <SimpleInput
                                id="input_text_recipient_contact"
                                name="contactNumber"
                                label="Kontak Penerima"
                                box="onlyNumber"
                                value={this.props.selectedData.contactNumber}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value?.trim())
                                }
                            />
                            <SimpleInput
                                id="input_text_stnk_name"
                                name="stnkName"
                                label="Nama STNK"
                                value={this.props.selectedData.stnkName}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value?.trim())
                                }
                            />
                            <SimpleInput
                                id="input_text_buyer_name"
                                name="buyer"
                                label="Nama Pembeli"
                                value={this.props.selectedData.buyer}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value?.trim())
                                }
                            />
                            <SimpleInput
                                id="input_text_frame_number"
                                name="frameNumber"
                                label="Nomor Rangka"
                                value={this.props.selectedData.frameNumber}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value?.trim())
                                }
                            />
                            <SimpleInput
                                id="input_text_engine_number"
                                name="engineNumber"
                                label="Nomor Mesin"
                                value={this.props.selectedData.engineNumber}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value?.trim())
                                }
                            />
                        </FlexView>
                        <FlexView hAlignContent="right" style={{gap: "10px"}}>
                            <SimpleButton
                                secondary
                                type="button"
                                text={"Clear"}
                                onClick={this.props.onClearForm}
                            />
                            <SimpleButton
                                type="submit"
                                text={"Terapkan"}
                                onClick={this.props.onSubmit}
                            />
                        </FlexView>

                        <SimpleLoadingOverlay active={this.state.loading}/>
                    </ModalContainer>
                }
            />
        );
    }
}

export default PenyerahanBBNLeasingFilter;
